export default class Path {
    static baseUrl = 'https://requestportal.my-gekko.com/create_request.php';
    static getAllRequests =
        'https://requestportal.my-gekko.com/get_requests.php';
    static basePath = 'https://requestportal.my-gekko.com';
}
